var selectedProduct = "Variety_One_Time";

// The `one_time_purchase_products` metaobject carries a `variant` reference
// ("Checkout Variant"), and the section renders each card's id from it as
// data-variant-id. That reference is the single source for the price shown on
// the card AND the id added to cart, so the two cannot disagree (issue #388).
// A slug -> product handle map used to live here; it was dead code and the
// variant reference replaces it.
//
// Fallback only. If the card attribute is missing — Checkout Variant unset on
// the metaobject entry, section edited — checkout still works rather than
// posting an empty id.
const SEAFOOD_TYPE_TO_ID = new Map();
SEAFOOD_TYPE_TO_ID.set("Salmon_One_Time", "51346359714066");
SEAFOOD_TYPE_TO_ID.set("Variety_One_Time", "51346398314770");

const FALLBACK_DISCOUNT_CODE = "25OFF";

// Prefer the id the section rendered from the live variant; fall back to the map.
function variantIdFor(seafoodType) {
  var card = document.querySelector(
    '.fish-card[data-variant-id][class~="' + seafoodType + '"]',
  );
  var fromDom = card && card.getAttribute("data-variant-id");
  if (fromDom && /^\d+$/.test(fromDom)) {
    return fromDom;
  }
  return SEAFOOD_TYPE_TO_ID.get(seafoodType);
}

// The card prices are computed from the section's discount settings, so the code
// applied here has to be the one those prices were computed against. Reading it
// off the section root keeps the advertised price and the applied code in step;
// changing the offer is then an editor change, not a code change.
function landingDiscountCode() {
  var root = document.querySelector(".landing-page[data-discount-code]");
  var code = root && root.getAttribute("data-discount-code");
  return code && code.trim() ? code.trim() : FALLBACK_DISCOUNT_CODE;
}

function lookForDiscountManager(resolve) {
  if (window?.discountManager) {
    resolve();
  } else {
    setTimeout(() => {
      lookForDiscountManager(resolve);
    }, 100);
  }
}

new Promise((resolve) => {
  lookForDiscountManager(resolve);
}).then(async () => {
  window.discountManager.setDiscountCode(landingDiscountCode());
  await window.discountManager.applyCurrentDiscount();

  $(document).ready(function () {

    /*******************************************
     * Product Choice Logic
     *******************************************/
    // Listen for seafood selection
    $("input[name='seafood']").on("click", async function () {
      selectedProduct = $("input[name=seafood]:checked").val();
    });

    /*******************************************
     * Page Setup Logic
     *******************************************/
    function setupDefaultSeafoodPlanCards() {
      $(".sub-select-card." + selectedProduct + " input").prop("checked", true);
    }

    function setupDefaults() {
      setupDefaultSeafoodPlanCards();
    }

    /*******************************************
     * Checkout Logic
     *******************************************/
    $(".checkout-button").click(async function () {
      // Each product modal renders its own .checkout-button, so a retry must
      // re-run only this button's checkout, not every one on the page.
      const $btn = $(this);
      try {
        // clear the cart b/c it might have old "freebie" products that are no longer free.
        // Inside the try: clearCart rejects on its own deadline, and that must
        // show the retry toast, not stop the click silently.
        await window.NttUtils.clearCart();

        window.discountManager.setDiscountCode(landingDiscountCode());
        await window.discountManager.applyCurrentDiscount();

        await window.NttUtils.addItemsToCart([
          { id: variantIdFor(selectedProduct), quantity: 1 },
        ]);
        location.href = "/checkout";
      } catch (error) {
        // In-app-browser abort: addItemsToCart rejected instead of redirecting
        // to an empty /checkout. Surface a retryable error.
        window.NttUtils.showCartError(
          "We couldn't start your checkout. Please check your connection and try again.",
          { onRetry: function () { $btn.trigger("click"); } },
        );
      }
    });

    setupDefaults();
  });
});
